<template>
  <el-dialog
    :title="formTitle"
    :visible.sync="isVisible"
    custom-class="dialog-long-form"
    :class="{'is-edit-mode': isEditMode, 'is-new': state === 'new'}"
    :closeOnClickModal="false"
    append-to-body>
    <div v-loading="isLoading">
      <form-market
        :data="data"
        :model="formModel"
        @change="handleFormData"
        ref="Form"/>
      <form-controls
        class="form-footer"
        isCancel
        :isCreate="!hasCreateNew"
        @command="setCommand"/>
    </div>
  </el-dialog>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import TabEditorWrap from '../TabEditorWrap'

export default {
  name: 'ModalNewMarket',
  mixins: [FormWrapper, TabEditorWrap],
  components: {
    'form-market': () => import(/* webpackChunkName: 'Companies' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    config: { type: Object },
    companyID: { type: Number, required: true }
  },
  computed: {
    formTitle () {
      return this.formData.title || this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    formModel () {
      return {
        id: null,
        followupDate: null,
        followupPerson: '',
        remarkSubjectID: null,
        remark: ''
      }
    },
    save () {
      if (!this.$refs.Form) {
        // eslint-disable-next-line
        return console.error('not found form')
      }
      this.isLoading = true
      this.$refs.Form.validate()
        .then(() => {
          this.$bus.$emit(`Call-ListForm-Create-${this.config.id}`,
            this.handlePrepareData(this.$refs.Form.getData()),
            (response) => this.gridCreateHandler(response)
          )
        })
        .catch(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style lang="stylus">
</style>
